import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FeatureStore {
  features: string[];
  setFeatures: (features: string[]) => void;
  reset: () => void;
}

export const useFeatureStore = create<FeatureStore>()(
  persist(
    (set) => ({
      features: [],
      setFeatures: (features) => set({ features }),
      reset: () => set({ features: [] })
    }),
    {
      name: 'feature-store', // stored in localStorage
      partialize: (state) => ({ features: state.features }),
    }
  )
);
